<template>
  <div class="videos">
    <div class="videoTitle">
      <router-link :to="{ path: '/facility', query: { cpNum: this.cpNum, nowIndex: nowIndex, name: '视频监控' }, params: { nowIndex: nowIndex, name: '视频监控' } }" replace>
        <p :title="'点击跳转物联数据页'" class="center">
          <img src="@/assets/img/report/report-video.png" alt="" />
        </p>
      </router-link>
    </div>
    <div class="videoList">
      <ul>
        <div class="noData" v-if="!list.length">
          <p class="img"></p>
          <p>暂无数据</p>
        </div>
        <li v-for="(item, index) in list" :key="index" v-else>
          <p class="videoAddress">监控地址:{{ item.v_video_address }}</p>
          <div class="surveillanceVideo">
            <div class="" v-if="item.isonly == 1" style="height: 200px;width: 98%;">
              <iframe :src="`https://open.ys7.com/ezopen/h5/iframe?url=${item.vUrl}`" width="100%" height="180px "> </iframe>
            </div>

            <div v-else @click="handlePlay(item, index)" class="cursor" style="height:200px;width: 98%;position:relative;">
              <cus-player :ref="'video' + index" :id="'video' + index" style="width: 100%"></cus-player>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { getVideo } from '@/api/facility';
import CusPlayer from '@/components/CusPlayer.vue';
import config from '@/utils/config';
export default {
  props: ['cpNum'],
  components: { CusPlayer },
  data() {
    return {
      list: [],
      token: null,
      index: 3,
      nowIndex: 3,
      videoLength: 0,
    };
  },
  watch: {
    cpNum(val) {
      this.list = val;
      this.getList();
    },
  },
  mounted() {
    if (this.cpNum) this.getList();
  },
  methods: {
    getList() {
      this.$get('basevideo/videotoken').then((data) => {
        // log(data);
        if (data.code == 200) {
          this.token = data.data;
          // log(this.token);
          getVideo({ c_company_num: this.cpNum }).then((res) => {
            // console.log(res, '2222222222');
            var arr = [];
            if (res.data.length) {
              if (this.cpNum) {
                var arr = [];
                res.data.map((item) => {
                  if (item.v_video_ip === 'J53116250') {
                    arr.push(item);
                  }
                });
                this.list = res.data;
              } else {
                this.list = arr;
              }
              this.list.map((item, index) => {
                if (item.isonly == 1) {
                  item.vUrl = `ezopen://open.ys7.com/${item.v_video_ip}/1.live&accessToken=${data.data}`;
                  item.turn = 0;
                } else {
                  item.vUrl = `${item.v_video_url ? item.v_video_url + '/live' : config.camraWs}?url=${item.url}`;
                  // console.log(item.vUrl); // undefined
                  item.turn = 'disabled';
                  item.isPlay = false;
                }
              });
            } else {
              this.list = [];
            }
          });
        }
      });
    },
    handlePlay(item, index) {
      log(item, index);
      if (item.isPlay == false) {
        if (item.vUrl) {
          let ref = 'video' + index;
          setTimeout(() => {
            this.$refs[ref][0].createPlayer(item.vUrl, false, index);
            item.isPlay = true;
          }, 10);
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
* {
  border: none !important;
}
.videos {
  width: 100%;
  height: 100%;
  border-radius: 2px;
  background: rgba(74, 157, 255, 0.38);
  padding: 3px;

  .videoTitle {
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 2px;
    line-height: 21.22px;
    color: rgba(42, 43, 49, 1);
    position: relative;
    .center {
      position: absolute;
      right: 0;
      display: flex;
      justify-content: flex-end;
      cursor: pointer;
      img {
        width: 25px;
        height: 20px;
      }
    }
  }
  .videoList {
    overflow: auto;
    width: 100%;
    position: relative;
    top: 5px;

    .surveillanceVideo {
      width: 100%;

      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-direction: column;
    }
    ul {
      li {
        .videoAddress {
          font-size: 12px;
          font-weight: 400;
          letter-spacing: 0px;
          color: rgba(0, 0, 0, 1);
        }
      }
    }
    .noData {
      z-index: 999999;
      width: 80px;
      position: absolute;
      top: 45%;
      left: 50%;
      text-align: center;
      line-height: 1;
      transform: translate(-50%, -50%) !important;
    }
  }
}
// *::-webkit-scrollbar-track {
//   /*滚动条里面轨道*/
//   // border-radius: 0;
//   // background: #fff;
// }
/*定义滑块 内阴影+圆角*/
*::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #badaff;
}
*::-webkit-scrollbar {
  width: 8px;
  height: 3px;
  background-color: #badaff;
}
/* 悬浮放大滚动滑块 */
*::-webkit-scrollbar-thumb:hover {
  //   background: #badaff;
  background-color: #2e2e2e;
  cursor: pointer !important;
  /*这里默认裁剪到border-box，以下使用shadow代替了边框大小*/
  //   border-width: 0;

  box-shadow: inset 3px 3px 3px hsl(0deg 0% 100% / 25%), inset -3px -3px 3px rgb(0 0 0 / 25%);
}
// 悬浮到滚动条所在位置上显示
*::-webkit-scrollbar-thumb {
  background: #7fa1c9;
  border-radius: 12px;
  /* padding-box 表示背景裁剪到内边距框，
      这里也可以用content-box,表示裁剪到内容框，
      默认为border-box，表示裁剪到边框*/
  background-clip: padding-box;
  border-style: solid;
  border-width: 2px;
  border-color: transparent;
}
</style>
